import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap, finalize } from "rxjs/operators";

import { AuthService } from "./auth.service";
import { AppEvents } from "../shared/app-events";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private readonly authService: AuthService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    AppEvents.beforeRequest.emit(req);

    return next.handle(req).pipe(
      tap({
        error: (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status !== 401 && err.status !== 403) {
              return;
            }
            console.warn(
              "Unauthenticated response detected...navigating to login..."
            );

            if (!this.isSignedFormController(req.url)) {
              this.authService.navigateToLoginAndReload();
            }
          }
        },
      }),
      tap({
        complete: () => {
          if (
            !this.authService.administrativeUnitId &&
            !this.isSignedFormController(req.url) &&
            !this.isPublicController(req.url) &&
            !this.isLogoutController(req.url)
          ) {
            this.authService.navigateToLogin();
          }
        },
      }),
      finalize(() => {
        AppEvents.afterRequest.emit(req);
      })
    );
  }

  isSignedFormController(url: string) {
    return url?.indexOf("api/signedforms") >= 0;
  }

  // Sign out clears the session and then sends the browser to a configured destination that may
  // be outside the app. Routing to the login page here would race that full page navigation.
  isLogoutController(url: string) {
    return url?.indexOf("api/logout") >= 0;
  }

  isPublicController(url: string) {
    // Add an exception for the specific endpoint
    const publicEndpoints = [
      "api/public",
      "api/data-list/due-process-filed-by",
      "api/data-list/due-process-responding-party",
      "api/data-list/mediation-requester",
      "api/data-list/relationships",
      "api/data-list/school-years",
      "api/data-list/communication-preference",
      "api/data-list/languages",
      "api/data-list/facilitation-meeting-types",
      "api/documents",
    ];
    return publicEndpoints.some((endpoint) => url.includes(endpoint));
  }
}
